import { AdvancedMarker } from '@vis.gl/react-google-maps'
import { tr } from '@/i18n'
import type { LatLng } from '@/types/structs'

/* MarkerId("firstPoint"): getFirstPointIcon() — hardcoded text "Alarm
 * activated" beside a pink circle (r30 at (42,36), black stroke 1.5) —
 * rendered at HEIGHT 32, anchor (0.14, 0.5).
 *
 * Design height 72 -> 32 px => x0.444: circle d~27px, stroke ~0.7px, text
 * 30 w700 -> ~13px, gaps ~5px. Canvas text has no fontFamily -> default
 * sans-serif.
 *
 * Anchor (0.14, 0.5) pins the CIRCLE's centre to the coordinate: from the
 * bottom-centre default, translateX(+36%) + translateY(+50%). */

export function FirstPointMarker({ position }: { position: LatLng }) {
  return (
    <AdvancedMarker position={position} zIndex={1}>
      <div
        data-marker="firstPoint"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 5,
          height: 32,
          transform: 'translate(36%, 50%)',
        }}
      >
        <div
          style={{
            width: 27,
            height: 27,
            borderRadius: '50%',
            background: 'var(--primary)',
            border: '0.7px solid #000000',
            flexShrink: 0,
          }}
        />
        <span
          style={{
            fontFamily: 'sans-serif',
            fontWeight: 700,
            fontSize: 13,
            lineHeight: 1,
            color: 'var(--primary)',
            whiteSpace: 'nowrap',
          }}
        >
          {tr.map.alarmActivated}
        </span>
      </div>
    </AdvancedMarker>
  )
}
